module.exports = __webpack_public_path__ + "img/passport.e560bc30.svg";